import { z } from 'zod'
import { FIELD_CANNOT_BE_EMPTY } from '../../../../consts/validationErrors'

export const requestEmailCodeSchema = z.object({
    email: z
        .string({ required_error: FIELD_CANNOT_BE_EMPTY })
        .trim()
        .min(1, { message: FIELD_CANNOT_BE_EMPTY })
        .email({ message: 'Введите корректный email' })
        .max(240, { message: 'Максимально 240 символа' }),
})

export const verifyEmailCodeSchema = z.object({
    code: z
        .string({ required_error: FIELD_CANNOT_BE_EMPTY })
        .trim()
        .min(1, { message: FIELD_CANNOT_BE_EMPTY })
        .regex(/^\d{6}$/, { message: 'Код должен содержать 6 цифр' }),
})

export type RequestEmailCodeFormValues = z.infer<typeof requestEmailCodeSchema>
export type VerifyEmailCodeFormValues = z.infer<typeof verifyEmailCodeSchema>
